import {NgModule} from '@angular/core';
import {AssetListingComponent} from './asset-listing.component';
import {SaleByUnitComponent} from './sale-by-unit/sale-by-unit.component';
import {FlexModule} from '@angular/flex-layout';
import {AngularMaterialModule, UiComponentModule} from '@rbaip/ui-component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ItemSellingMethodComponent} from './item-selling-method/item-selling-method.component';
import {CommonModule} from '@angular/common';

@NgModule({
  declarations: [
    AssetListingComponent,
    SaleByUnitComponent,
    ItemSellingMethodComponent
  ],
  imports: [
    FlexModule,
    UiComponentModule,
    FormsModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    CommonModule
  ],
  exports: [
    AssetListingComponent
  ]
})
export class ItemListingModule {

}
